// @ts-check
// const { cmyk } = require('color-convert');

const { getRoomName } = require('./stands');
const slug = require('slugify').default;

const colors2018 = {
  halle: '#986C95', //`#${cmyk.hex([45, 65, 20, 0])}`,
  erzherzogKarl: '#50BDC7', //`#${cmyk.hex([60, 0, 20, 5])}`,
  gartensaal: '#504A48', //`#${cmyk.hex([40, 40, 40, 0])}`,
  seitenhalle: '#1074BB', // `#${cmyk.hex([85, 50, 0, 0])}`,
  prinzEugenSaal: '#1EB0E6', // `#${cmyk.hex([70, 10, 0, 0])}`,
  gardehalleII: '#00480F', // `#${cmyk.hex([80, 0, 100, 75])}`,
  passageraum: '#3D2B1E', // `#${cmyk.hex([60, 70, 80, 60])}`,
  gardehalleI: '#6D732C', // `#${cmyk.hex([53, 36, 100, 25])}`,
  forum: '#EF4862', // `#${cmyk.hex([0, 87, 50, 0])}`,
  feststiege: '#F4882A', // `#${cmyk.hex([0, 56, 95, 0])}`,
  platzl: '#DDB236', // `#${cmyk.hex([10, 25, 90, 5])}`,
  vorsaal: '#F37E5F', // `#${cmyk.hex([0, 63, 63, 0])}`,
  hofburgLounge: '#590E3A', // `#${cmyk.hex([43, 95, 38, 52])}`,
  seitengalerie: '#A5CE43', // `#${cmyk.hex([40, 0, 95, 0])}`,
  hofburgGalerie: '#B5B540', // `#${cmyk.hex([30, 16, 90, 3])}`,
  festsaal: '#B63E7C', // `#${cmyk.hex([30, 90, 25, 0])}`,
  orchestergang: '#456773', // `#${cmyk.hex([72, 43, 38, 25])}`,
  wintergarten: '#2B3840', // `#${cmyk.hex([20, 0, 0, 90])}`,
  zeremoniensaal: '#71AB44', // `#${cmyk.hex([62, 12, 100, 0])}`,
  marmorsaal: '#2A4628', // `#${cmyk.hex([77, 46, 87, 51])}`,
  antekammer: '#716A5B', // `#${cmyk.hex([25, 25, 40, 50])}`,
  rittersaal: '#FBB52B', // `#${cmyk.hex([0, 32, 93, 0])}`,
  trabantenstube: '#966D55', // `#${cmyk.hex([10, 40, 50, 40])}`,
};

/** @type {Record<'parterre' | 'mezzanin', Floor>} */
const floors = {
  parterre: { slug: 'parterre', name: 'Parterre' },
  mezzanin: { slug: 'mezzanin', name: 'Mezzanin' },
};

/** @type {Room[]} */
const parterre = [
  {
    name: 'Halle',
    colors: { primary: colors2018.halle },
    subtitle:
      'VieVinum Hospitality Desk, Anker, ÖWI, Vöslauer, Medien & Partner, Austrian Wine Lounge',
  },
  {
    name: 'Erzherzog Karl Saal',
    colors: { primary: '#009849' },
    subtitle: 'Gösser Business-Lounge',
  },
  {
    name: 'Seitenhalle',
    colors: { primary: colors2018.erzherzogKarl },
    subtitle: 'Thermenregion',
    tableNumbers: '1-16',
  },
  {
    name: 'Prinz Eugen Saal',
    colors: { primary: colors2018.gartensaal },
    subtitle: 'Kremstal & Kamptal',
    tableNumbers: '17-50',
  },
  {
    name: 'Gardehalle II',
    tableNumbers: '51-75',
    colors: { primary: colors2018.seitenhalle },
    subtitle: 'Wagram',
  },
  {
    name: 'Gardehalle I',
    tableNumbers: '79-93',
    colors: { primary: colors2018.prinzEugenSaal },
    subtitle: 'Burgundermacher, Traisental, Wachau',
  },
  {
    name: 'Forum',
    tableNumbers: '97-136',
    colors: { primary: colors2018.gardehalleII },
    subtitle: 'Vinea Wachau',
  },
  {
    name: 'Feststiege',
    tableNumbers: '140-143',
    colors: { primary: colors2018.gardehalleI },
    subtitle: 'Döllerer',
  },
].map((room) => ({
  ...room,
  tableFirst: Number(room.tableNumbers?.split('-')[0]),
  tableLast: Number(room.tableNumbers?.split('-')[1]),
  slug: slug(room.name, { lower: true }),
  floor: floors.parterre,
}));

/** @type {Room[]} */
const mezzanin = [
  {
    name: 'Metternichsaal',
    tableNumbers: '147–211',
    colors: { primary: colors2018.forum },
    subtitle: 'Wien, Österreichische Traditionsweingüter (ÖTW), Carnuntum',
  },
  {
    name: 'Vorsaal',
    tableNumbers: '212–237',
    colors: { primary: colors2018.vorsaal },
    subtitle: 'Junge Wilde Winzer, Demeter, Taste of Austria, Juroa, Retter',
  },
  {
    name: 'Hofburg Lounge',
    tableNumbers: '238–246',
    colors: { primary: 'rgb(98, 25, 59)' },
    subtitle: 'Gastregionen Südtirol & Sizilien',
  },
  {
    name: 'Seitengalerie',
    tableNumbers: '250–283',
    colors: { primary: colors2018.seitengalerie },
    subtitle: 'Weinviertel',
  },
  {
    name: 'Hofburg Galerie',
    tableNumbers: '287–319',
    colors: { primary: colors2018.hofburgGalerie },
    subtitle: 'Weinviertel',
  },
  {
    name: 'Festsaal & Orchestergang',
    tableNumbers: '335–451',
    colors: { primary: colors2018.festsaal },
    subtitle: 'Burgenland',
  },
  {
    name: 'Wintergarten',
    tableNumbers: '471–490',
    colors: { primary: colors2018.orchestergang },
    subtitle:
      'Sommelier Union Austria, Weinakademie, AF-Wein, Burschik, P.M. Mounier, Morandell/Vinorama, Weinbrand & Spirituosen, Sekt Austria',
  },
  {
    name: 'Zeremoniensaal',
    tableNumbers: '492–551',
    colors: { primary: colors2018.zeremoniensaal },
    subtitle: 'Steiermark & Kärnten',
  },
  {
    name: 'Geheime Ratstube',
    colors: { primary: colors2018.wintergarten },
    subtitle: 'Falstaff Lounge',
    hidePlan: true,
  },
  {
    name: 'Marmorsaal',
    tableNumbers: '553–565',
    colors: { primary: colors2018.marmorsaal },
    subtitle: 'VDP.Die Prädikatsweingüter',
  },
  {
    name: 'Antekammer',
    tableNumbers: '579–591',
    colors: { primary: colors2018.antekammer },
    subtitle:
      'Deutschland, Italien, Griechenland, Slowenien, Polen, Ungarn-Kroatien, Idee Exclusiv Pfurtscheller',
  },
  {
    name: 'Trabantenstube',
    colors: { primary: colors2018.trabantenstube },
    subtitle: 'Lavazza Lounge presented by A LA CARTE',
  },
].map((room) => ({
  ...room,
  tableFirst: Number(room.tableNumbers?.split('–')[0]),
  tableLast: Number(room.tableNumbers?.split('–')[1]),
  slug: slug(room.name, { lower: true }),
  floor: floors.mezzanin,
}));

floors.parterre.rooms = parterre;
floors.mezzanin.rooms = mezzanin;

const rooms = [...parterre, ...mezzanin];

/** @param {string | undefined} standName  */
function findRoomByStandName(standName) {
  const roomName = getRoomName(standName);
  if (roomName === 'Festsaal' || roomName === 'Orchestergang') {
    return rooms.find((room) => room.name === 'Festsaal & Orchestergang');
  }
  return rooms.find(({ name }) => name === roomName);
}

module.exports = {
  floors,
  rooms,
  findRoomByStandName,
};

/**
@typedef {{
  slug?: string;
  name: string;
  subtitle?: string;
  colors?: { primary: string; onPrimary?: string };
  tableNumbers?: string;
  tableFirst?: number;
  tableLast?: number;
  floor: Floor;
  hidePlan?: boolean;
}} Room
*/
/**
@typedef {{
  slug: string;
  name: string;
  rooms?: Room[];
 }} Floor
 */
